import type { ModuleName } from '@/constants/modules'

/** Whether a module is active in the current deployment manifest. */
export function isModuleActive(activeModules: readonly ModuleName[], name: ModuleName): boolean {
  return activeModules.includes(name)
}
